import { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
import storage from 'redux-persist/lib/storage'
import { persistStore, persistReducer } from 'redux-persist'
import appReducer from './reducers'

// const tokenName = process.env.REACT_APP_REFRESH_TOKEN
const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const storageKey = process.env.REACT_APP_STORAGE_KEY

const initialState = {};


const persistConfig = {
    key: storageKey,
    storage,
    whitelist: ['auth']
}
export const rootReducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        storage.removeItem('persist:'+storageKey)
        localStorage.removeItem(accessToken)
        state = initialState;
        window.location = '/login'
    }  
    return appReducer(state, action)
}

const persistedReducer = persistReducer(persistConfig, rootReducer)


const AppStore = configureStore({
    reducer: persistedReducer,
    middleware: [thunk],
    initialState: initialState   
});
let persistor = persistStore(AppStore)
export { AppStore, persistor };